import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SanitizeService } from 'src/app/services/sanitize.service';
import { TenantConfService } from 'src/app/services/tenant-conf.service';

@Component({
  selector: 'app-citycard-banner',
  templateUrl: './citycard-banner.component.html',
  styleUrls: ['./citycard-banner.component.scss']
})
export class CitycardBannerComponent implements OnInit {
  @Input() data;

  fidelityCardUrl: any;

  constructor(
    private tenantService: TenantConfService,
    private translate: TranslateService, 
    public sanitizeService: SanitizeService) {
      this.fidelityCardUrl = this.tenantService.getFidelityCardUrl();
    }

  ngOnInit() {}
}
